import {
    CreditCard,
    FileText,
    User,
    ExternalLink,
} from "lucide-react";

import getImageUrl from "../../../utils/imageUrl";

import "./DocumentsCard.css";

function DocumentsCard({ partner }) {

    const documents = partner.documents || {};

    const documentList = [

        {
            title: "Aadhaar Front",
            icon: <CreditCard size={20} />,
            file: documents.aadhaarFront,
            folder: "delivery",
        },

        {
            title: "Aadhaar Back",
            icon: <CreditCard size={20} />,
            file: documents.aadhaarBack,
            folder: "delivery",
        },

        {
            title: "PAN Card",
            icon: <FileText size={20} />,
            file: documents.panCard,
            folder: "delivery",
        },

        {
            title: "Profile Photo",
            icon: <User size={20} />,
            file: documents.profilePhoto,
            folder: "delivery",
        },

    ];

    const openDocument = (file, folder) => {

        if (!file) {
            return;
        }

        const url = getImageUrl(
            `/uploads/${folder}/${file}`
        );

        window.open(url, "_blank");
    };

    return (

        <div className="documents-card">

            <div className="card-title">

                <h3>KYC Documents</h3>

            </div>

            <div className="documents-grid">

                {documentList.map((doc) => {

                    const documentUrl = doc.file
                        ? getImageUrl(
                            `/uploads/${doc.folder}/${doc.file}`
                        )
                        : "";

                    return (

                        <div
                            key={doc.title}
                            className="document-item"
                        >

                            <div className="document-header">

                                {doc.icon}

                                <span>
                                    {doc.title}
                                </span>

                            </div>

                            {doc.file ? (

                                <>

                                    <img
                                        src={documentUrl}
                                        alt={doc.title}
                                        className="document-image"
                                        onError={(e) => {
                                            e.currentTarget.style.display =
                                                "none";
                                        }}
                                    />

                                    <button
                                        type="button"
                                        className="view-document-btn"
                                        onClick={() =>
                                            openDocument(
                                                doc.file,
                                                doc.folder
                                            )
                                        }
                                    >

                                        <ExternalLink
                                            size={16}
                                        />

                                        View Document

                                    </button>

                                </>

                            ) : (

                                <div className="document-placeholder">

                                    No Document Uploaded

                                </div>

                            )}

                        </div>

                    );

                })}

            </div>

        </div>

    );
}

export default DocumentsCard;